import { assertNever } from '@kofno/piper';
import { State } from '../Types';
import UserGroupMembershipsStore from '../index';
import ErrorActionableReaction, { EAProps } from '../../../../../../../../ErrorActionableReaction';
import { loadForNew } from './LoadForNew';
import { create } from './Create';

interface Props extends EAProps<UserGroupMembershipsStore> {}

class AddUserGroupMembershipsReactions extends ErrorActionableReaction<
  UserGroupMembershipsStore,
  State,
  Props
> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'loading-for-new':
        loadForNew(store.participantsStore.links, store);
        break;
      case 'creating':
        create(store, state);
        break;
      case 'succeeded':
      case 'waiting':
      case 'ready':
      case 'error':
      case 'load-error':
      case 'new-form-submission-error':
        break;
      default:
        assertNever(state);
    }
  };
}

export default AddUserGroupMembershipsReactions;
